import React from 'react'
import exportFree from '../functions/exportFree'
import StripeButton from '../functions/StripeButton'

const ExportButton = (props) => {
  return props.label === 'Free' ? (
    <div>
      <button onClick={exportFree}>
        Export {props.label} Design
        <i className="far fa-arrow-alt-circle-down"></i>
      </button>
      <p className="watermark">
        <small>{props.watermark}</small>
      </p>
    </div>
  ) : props.clientHasPaid ? (
    <div>
      <button onClick={exportFree}>
        {props.label}
        <i className="far fa-arrow-alt-circle-down"></i>
      </button>
    </div>
  ) : (
    <div>
      <StripeButton
        label={props.label}
        name={props.name}
        description={props.description}
        amount={props.amount}
      />
      <p className="description">
        <small>{props.description}</small>
      </p>
    </div>
  )
}

export default ExportButton
